import axios from "axios";

// Use relative paths so the same build works on any domain.
export const API = "";

const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export default adminApi;
